import { css, unsafeCSS, html } from "lit";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
const cssVars = {
  grow: "--dsf-row-grow",
  shrink: "--dsf-row-shrink",
  basis: "--dsf-row-basis",
  justify: "--dsf-row-justify",
  align: "--dsf-row-align",
  gap: "--dsf-row-gap"
};
let DsfRow = class extends BaseComponent {
  updateCssVar(varKey, value) {
    const cssVar = cssVars[varKey];
    if (value) {
      this.style.setProperty(cssVar, value.toString());
    } else {
      this.style.removeProperty(cssVar);
    }
  }
  update(changeProps) {
    super.update(changeProps);
    this.updateCssVar("grow", this.dsf_grow);
    this.updateCssVar("shrink", this.dsf_shrink);
    this.updateCssVar("justify", this.dsf_justify);
    this.updateCssVar("align", this.dsf_align);
    this.updateCssVar("gap", this.dsf_gap && `var(--dsf-spacing-${this.dsf_gap})`);
    this.updateCssVar("basis", this.dsf_basis);
  }
  render() {
    return html`<slot></slot>`;
  }
};
DsfRow.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: flex;
        flex-direction: row;
        flex-basis: var(${unsafeCSS(cssVars.basis)}, 100%);
        flex-shrink: var(${unsafeCSS(cssVars.shrink)}, 1);
        flex-grow: var(${unsafeCSS(cssVars.grow)}, 1);
        justify-content: var(${unsafeCSS(cssVars.justify)}, left);
        align-items: var(${unsafeCSS(cssVars.align)}, center);
        gap: var(${unsafeCSS(cssVars.gap)}, 0);
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfRow.prototype, "dsf_shrink", 2);
__decorateClass([
  prop({ type: String })
], DsfRow.prototype, "dsf_grow", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfRow.prototype, "dsf_gap", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfRow.prototype, "dsf_justify", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfRow.prototype, "dsf_align", 2);
__decorateClass([
  prop({ type: String })
], DsfRow.prototype, "dsf_basis", 2);
DsfRow = __decorateClass([
  defineElement("dsf-row")
], DsfRow);
export {
  DsfRow
};
